/**
 * In-store vendors (B17, ADR 0006): every call goes to the StoreVendor model.
 *   vendor*  the vendor portal (`/vendor`, MP_VENDOR session)
 *   mkt*     the store admin's Vendors pages (`/admin/vendors`, staff session)
 */
const act = (action, data = {}) => ({ url: '/api/crud/StoreVendor', method: 'POST', data: { action, data } });

export default {
  // ---- vendor portal ----------------------------------------------------
  vendorSession: () => act('session'),
  vendorSignIn: ({ email, password }) => act('signIn', { email, password }),
  vendorApply: (data) => act('apply', data),
  vendorSignOut: () => act('signOut'),
  // Set-password links (MERCH-107): the token travels in the POST body, never in an API URL.
  vendorForgotPassword: ({ email }) => act('forgotPassword', { email }),
  vendorPasswordLink: ({ token }) => act('passwordLink', { token }),
  vendorSetPassword: ({ token, password }) => act('setPassword', { token, password }),
  vendorMe: () => act('me'),
  vendorUpdateProfile: (data) => act('updateMyProfile', data),
  vendorChangePassword: ({ current, next }) => act('changePassword', { current, next }),
  vendorCategoryTree: () => act('categoryTree'),
  vendorProducts: (params = {}) => act('myProducts', params),
  vendorCreateProduct: (data) => act('createProduct', data),
  vendorUpdateProduct: (data) => act('updateProduct', data),
  vendorOrders: (params = {}) => act('myOrders', params),
  vendorShipLine: ({ id, carrier, tracking }) => act('shipLine', { id, carrier, tracking }),
  vendorEarnings: () => act('myEarnings'),

  // ---- store admin --------------------------------------------------------
  mktVendors: (params = {}) => act('vendors', params),
  mktAddVendor: (data) => act('add', data),
  // action: approve | reject | suspend | reinstate
  mktReviewVendor: ({ action, ...data }) => act(action, data),
  mktSetVendorCommission: ({ id, commission_pct, version }) => act('setCommission', { id, commission_pct, version }),
  mktSetDefaultCommission: ({ commission_pct }) => act('setDefaultCommission', { commission_pct }),
  mktProducts: (params = {}) => act('vendorProducts', params),
  mktReviewProduct: ({ id, decision, note }) => act('reviewProduct', { id, decision, note }),
  mktSetProductCommission: ({ id, commission_pct }) => act('setProductCommission', { id, commission_pct }),
  mktEarnings: () => act('vendorEarnings'),
};
